/* eslint-disable func-names */
import { TweenLite } from 'gsap';
import store from '../../utils/localStorageFallback';
import VERSION_OPTIONS from '../../../gutenberg/configs/versions';

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const hideSections = () => {
  const storeVersion = store('version');
  let sectionsToHide = [];

  if (storeVersion === 'investor') {
    sectionsToHide = document.querySelectorAll(`.${storeVersion}, .investors`);
  } else {
    sectionsToHide = document.getElementsByClassName(`${storeVersion}`);
  }

  for (let i = 0; i < sectionsToHide.length; i += 1) {
    sectionsToHide[i].classList.remove('u-hidden');
  }
};

const forceRoleRedirect = () => {
  const user = store('version');

  if (document.body.classList.contains('adviser') || document.body.classList.contains('investor')) {
    // in a restricted page/ post / product.
    if (!document.body.classList.contains(user)) {
      // redirect to home if now allowed.
      document.location.href = '/';
    }
  }
};

const resourceCentreReload = () => {
  const path = document.location.pathname;

  if (path === '/resources/') {
    document.location.reload();
  }
};

docReady(() => {
  // DOM is loaded and ready for manipulation here
  // const btn = document.getElementById('modal-opener');
  const modal = document.querySelector('.modal');

  // eslint-disable-next-line no-undef
  const resetDisclaimer = deepsea_investments.reset_disclaimer;
  // eslint-disable-next-line no-undef
  const resetDisclaimerTimestamp = deepsea_investments.reset_disclaimer_timestamp;
  const versionConfirmedTimestamp = store('version-confirmed-timestamp');
  const userTimestamp = Math.floor(new Date().getTime() / 1000);

  if (
    resetDisclaimer === '1' &&
    resetDisclaimerTimestamp > versionConfirmedTimestamp &&
    userTimestamp > resetDisclaimerTimestamp
  ) {
    localStorage.removeItem('investor-confirmed');
    localStorage.removeItem('adviser-confirmed');
    localStorage.removeItem('institutional-investor-confirmed');
  }

  const toggleModal = () => {
    const currentState = modal.style.display;
    // If modal is visible, hide it. Else, display it.
    if (currentState === 'none') {
      modal.style.display = 'block';
    } else {
      modal.style.display = 'none';
    }
  };

  const handleScrollTo = hash => {
    let element = null;

    const elements = document.querySelectorAll(`[id="${hash.substring(1)}"]`);
    Object.values(elements).some(el => {
      if (el.offsetTop !== 0) {
        element = el;

        return true;
      }

      return false;
    });

    if (element === null) {
      return false;
    }

    const header = document.querySelector('.site-header');
    const actionBar = document.querySelector('.action-bar');

    let additionalOffset = 20;
    if (actionBar !== null && actionBar.classList.contains('fixed')) {
      additionalOffset = actionBar.offsetHeight + 20;
    }

    TweenLite.to(window, 0.6, {
      scrollTo: {
        y: element.offsetTop,
        offsetY: header.offsetHeight + additionalOffset,
      },
    });

    return false;
  };

  const showConfirmScreen = (value, withoutAnimation = false) => {
    const stepOne = document.getElementsByClassName('modal-content-role-select')[0];
    const stepTwo = document.getElementsByClassName(`${value}-confirm`)[0];
    if (withoutAnimation === false) {
      TweenLite.to(stepOne, 0.3, { autoAlpha: 0, display: 'none' });
      TweenLite.to(stepTwo, 0.3, { autoAlpha: 1, delay: 0.3, display: 'block' });
    } else {
      stepOne.style.display = 'none';
      if (stepTwo !== undefined) {
        stepTwo.style.display = 'block';
      }
    }

    const advisorConfirm = document.getElementsByClassName('adviser-confirm-button')[0];
    const investorConfirm = document.getElementsByClassName('investor-confirm-button')[0];
    const instititonalInvestorConfirm = document.getElementsByClassName(
      'institutional-investor-confirm-button',
    )[0];
    const noOptionConfirm = document.getElementsByClassName('no-option-confirm-button')[0];

    if (value !== 'no-option') {
      const utilityNavButtonLi = document.querySelector(`.utilityNav-button.${value}-btn`);
      if (utilityNavButtonLi !== null) {
        utilityNavButtonLi.classList.add('active');
      }
    }

    if (value === 'no-option') {
      const utilityNavButtonLi = document.querySelector(`.utilityNav-button.investor-btn`);
      if (utilityNavButtonLi !== null) {
        utilityNavButtonLi.classList.add('active');
      }
    }

    advisorConfirm.addEventListener('click', () => {
      store('version', 'adviser');
      store('adviser-confirmed', 'true');
      store('version-confirmed-timestamp', resetDisclaimerTimestamp);
      hideSections();
      forceRoleRedirect();
      resourceCentreReload();
      toggleModal();
      stepTwo.style.display = 'none';

      if (window.location.hash) {
        handleScrollTo(window.location.hash);
      }
    });

    investorConfirm.addEventListener('click', () => {
      store('version', 'investor');
      store('investor-confirmed', 'true');
      store('version-confirmed-timestamp', resetDisclaimerTimestamp);
      hideSections();
      forceRoleRedirect();
      resourceCentreReload();
      toggleModal();
      stepTwo.style.display = 'none';

      if (window.location.hash) {
        handleScrollTo(window.location.hash);
      }
    });

    instititonalInvestorConfirm.addEventListener('click', () => {
      store('institutional-investor-confirmed', 'true');
      store('version-confirmed-timestamp', resetDisclaimerTimestamp);
      // eslint-disable-next-line no-undef
      window.location.href = `${deepsea_investments.institutional_website_link}#content-institutional-investor`;
    });

    noOptionConfirm.addEventListener('click', () => {
      store('version', 'investor');
      store('version-confirmed-timestamp', resetDisclaimerTimestamp);
      hideSections();
      forceRoleRedirect();
      resourceCentreReload();
      toggleModal();
      stepTwo.style.display = 'none';
    });
  };

  // add in buttons to the dom
  for (let i = 0; i < VERSION_OPTIONS.length; i += 1) {
    const button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.setAttribute('class', 'btn wp-block-button');
    button.setAttribute('value', VERSION_OPTIONS[i].value);
    button.textContent = VERSION_OPTIONS[i].label;

    const modalContent = document.querySelector('.modal-content-role-select');

    modalContent.appendChild(button);

    button.addEventListener('click', function() {
      showConfirmScreen(this.value);
    });
  }

  // add institutional investor button
  const institutionalInvestorButton = document.createElement('button');
  institutionalInvestorButton.setAttribute('type', 'button');
  institutionalInvestorButton.setAttribute('class', 'btn wp-block-button');
  institutionalInvestorButton.setAttribute('value', 'institutional-investor');
  institutionalInvestorButton.textContent = 'Institutional investor';

  const modalContent = document.querySelector('.modal-content-role-select');
  modalContent.appendChild(institutionalInvestorButton);

  institutionalInvestorButton.addEventListener('click', function() {
    showConfirmScreen(this.value);
  });

  // add "I don’t see myself here"
  const noOptionButton = document.createElement('button');
  noOptionButton.setAttribute('type', 'button');
  noOptionButton.setAttribute('class', 'btn no-option');
  noOptionButton.setAttribute('value', 'no-option');
  noOptionButton.textContent = `I'm none of these`;

  modalContent.appendChild(noOptionButton);

  noOptionButton.addEventListener('click', function() {
    showConfirmScreen(this.value);
  });

  // eslint-disable-next-line no-unused-vars
  const resetVersion = () => {
    localStorage.removeItem('version');

    for (let i = 0; i < VERSION_OPTIONS.length; i += 1) {
      const sectionsToHide = document.getElementsByClassName(`${VERSION_OPTIONS[i].value}`);

      for (let j = 0; j < sectionsToHide.length; j += 1) {
        sectionsToHide[j].classList.add('u-hidden');
      }
    }

    if (!store('version')) {
      toggleModal();
    } else {
      hideSections();
    }
  };

  const version = store('version');
  if (version && !store(`${version}-confirmed`)) {
    showConfirmScreen(version, true);
    setTimeout(toggleModal, 100);
  }

  // btn.addEventListener('click', resetVersion);
  if (!version) {
    toggleModal();
  } else {
    hideSections();
    // forceRoleRedirect();
  }
});
